import {Injectable} from '@angular/core';
import {EvkHttpService, EvkOption, EvkResponseType} from '@evomatik/evk-common';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {IdPais} from '../enums/idpais.enum';
import {CatalogoValor} from '../models/catalogo-valor.model';

@Injectable({
    providedIn: 'root'
})
export class CatalogosService {

    constructor(
        private http: EvkHttpService
    ) {
    }

    public getValuesByDiscriminatorPadre = (discriminatorPadre: string): Observable<CatalogoValor[]> => {
        return this.http.get<EvkResponseType<CatalogoValor[]>>(`/seaged-catalogos/catalogos/discriminador-padre/${discriminatorPadre.toUpperCase()}/list`).pipe(
            map(resoponse => resoponse.data));
    }

    public getByDiscriminator = (discriminator: string): Observable<EvkOption[]> => {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/catalogos/${discriminator.toUpperCase()}/options`)
            .pipe(map(resoponse => resoponse.data));
    }
    public getByDiscriminatorSimpleOptions = (discriminator: string): Observable<EvkOption[]> => {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/catalogos/${discriminator.toUpperCase()}/simple-options`)
            .pipe(map(resoponse => resoponse.data));
    }

    public getPaises(): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/paises/options`).pipe(
            map(response => response.data));
    }

    /**
     * Carga estados filtrado por id de país
     * @param id idPais. Por defecto México (environment.catalogo.pais.mexico)
     */
    public getEstados(id: any): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(
            `/seaged-catalogos/estados/paises/${id}/estados/options`).pipe(
            map(response => response.data));
    }

    /**
     * Carga municipios filtrado por id estado
     * @param id idEstado. Por defecto Aguascalientes (environment.catalogo.estado.ags)
     */
    public getMunicipios(id: any): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(
            `/seaged-catalogos/municipios/estados/${id}/municipios/options`).pipe(
            map(response => response.data));
    }
    public getMunicipiosInegi(id: any): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(
            `/seaged-catalogos/municipios-inegi/by-estado/${id}/options`).pipe(
            map(response => response.data));
    }

    public getLocalidades(id: number): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(
            `/seaged-catalogos/localidades/municipio/${id}/localidades/options`).pipe(map(response => response.data));
    }

    public getLocalidadesInegi(id: any): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(
            `/seaged-catalogos/localidades-inegi/by-municipio/${id}/options`).pipe(map(response => response.data));
    }

    public getEstadosByPaisMexico() {
        return this.getEstados(IdPais.MEXICO);
    }

    public getValueByDiscriminadorAndValor(discriminador: string, idValor: string): Observable<CatalogoValor> {
        return this.http.get<EvkResponseType<CatalogoValor>>(`/seaged-catalogos/catalogos/by-id/${discriminador}/${idValor}`).pipe(
            map(response => response.data)
        );
    }

    public getBuscaCp(cp: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-catalogos/colonias/listColoniaByCp/${cp}`).pipe(
            map(response => response.data));
    }

    /**
     * Carga colonias filtrado por id municipio
     * @param id idMunicipio
     */
    public getColonias(id: number): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(
            `/seaged-catalogos/colonias/municipios/${id}/colonias/options`).pipe(
            map(response => response.data));
    }

    public getColoniasInegi(id: any): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(
            `/seaged-catalogos/colonias-inegi/by-localidad/${id}/options`).pipe(
            map(response => response.data));
    }

    public getColoniaById(id: number) {
        return this.http.get<EvkResponseType<any>>(`/seaged-catalogos/colonias/${id}`).pipe(
            map(response => response.data));
    }

    public getUsuariosParaConfigurarProyecto() {
        return this.http.get<EvkResponseType<any>>(`/seaged-catalogos/usuario-organizacion/list/usuarios/configuracion-proyecto-tickets`).pipe(
            map(response => response.data));
    }

    public expedientesByNombreProyectoOptions() {
        return this.http.get<EvkResponseType<any>>(`/seaged-expedientes-service/expediente/ByNombreProyecto/options`).pipe(
            map(response => response.data));
    }

    public expedientesByClienteOptions() {
        return this.http.get<EvkResponseType<any>>(`/seaged-expedientes-service/expediente/ByNombreCliente/options`).pipe(
            map(response => response.data));
    }

    public proyectosByUsernameOptions(username: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-expedientes-service/expediente/catalogos/proyectos/by-usuario/${username}`).pipe(
            map(response => response.data));
    }

    public findTicketByProyectoLabelInAndDistintRepresentanteOptions(proyectos: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-tickets-service/ticket/by/proyectos/${proyectos}`).pipe(
            map(response => response.data));
    }

    public findUsuarioProyectoByGrupoValueAndIdExpedienteAndTipoInterno = (grupo: string, idExpediente: string): Observable<EvkOption[]> => {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-tickets-service/usuario-proyecto/by/grupo/${grupo}/expediente/${idExpediente}`)
            .pipe(map(resoponse => resoponse.data));
    }
    public findUsuarioProyectoByGrupoValueAndIdExpedienteAndTipoInternoAndGuardiaTrue = (grupo: string, idExpediente: string): Observable<EvkOption[]> => {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-tickets-service/usuario-proyecto/by/grupo/${grupo}/expediente/${idExpediente}/guardia`)
            .pipe(map(resoponse => resoponse.data));
    }

    public getTicketResumen(idExpediente: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-tickets-service/ticket/by/expediente/${idExpediente}`).pipe(
            map(response => response.data)
        );
    }

    public getDiligencia(idDiligencia: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-diligencias-service/diligencia/show/${idDiligencia}`).pipe(
            map(response => response.data)
        );
    }

    public getTareaDocument(idDiligencia: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-diligencias-service/tarea/negocio-diligencia/${idDiligencia}`).pipe(
            map(response => response.data)
        );
    }

    public getDiligenciaConfigById(idDiligenciaConfig: any) {
        return this.http.get<EvkResponseType<any>>('/seaged-diligencias-service/diligencia-config/' + idDiligenciaConfig).pipe(
            map(response => response.data));
    }

    public getOrganizacionesByIdDiligencia(idDiligencia: string) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/organizacion/asignacion/options/by-id-diligencia/${idDiligencia}`).pipe(
            map(response => response.data)
        );
    }

    public getUsuariosByIdUnidadAndRoles(idOrganizacion: string, roles: string) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/usuario-organizacion/organizacion/${idOrganizacion}/rol/options?roles=${roles}`).pipe(
            map(response => response.data)
        );
    }

    public getOrganizacionByTipo(idTipo): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/organizacion/options/by-tipo-organizacion/${idTipo}`).pipe(
            map(response => response.data));
    }

    public getTipoOrganizacionTurnadoByIdOrganizacionAndTipo(tipoOrganizacion, idOrganizacion): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/config-multiple-turnado-autorizacion/${tipoOrganizacion}/${idOrganizacion}/options`).pipe(
            map(response => response.data));
    }

    public getTipoOrganizacionTurnadoByIdDiligenciaConfig(idConfig): Observable<EvkOption[]> {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-diligencias-service/diligencia-config/${idConfig}/tipoOrganizacion/options`).pipe(
            map(response => response.data));
    }

    public getUsuariosForUnidadOrganizacionalLogica(id: any, args: any [], username: string): Observable<EvkOption[]> {
        const data: EvkResponseType<any> = {
            id: '',
            data: args,
        };
        return this.http.post<EvkResponseType<EvkOption[]>>('/seaged-auth-service/usuario/organizacion/roles/' + id, data).pipe(
            map(response => response.data.filter(usuario => usuario.value !== username))
        );
    }

    public getOrganizacionById(idOrganizacion: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-catalogos/organizacion/${idOrganizacion}`).pipe(
            map(response => response.data)
        );
    }

    public getTipoOrganizacionByOrganizacionById(idOrganizacion: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-catalogos/tipo-organizacion/by-organizacion/${idOrganizacion}`).pipe(
            map(response => response.data)
        );
    }

    public getTiposPatron(idDiligenciaConfig: any) {
        return this.http.get<EvkResponseType<any>>('/seaged-diligencias-service/diligencia-config/' + idDiligenciaConfig).pipe(
            map(response => response.data));
    }

    public getTiposOrganizacionesByOrganizacionOrigenAndTipoConfiguracion(idOrganizacion: any, tipoConfiguracion: any) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/tipo-organizacion/options/${idOrganizacion}/${tipoConfiguracion}`).pipe(
            map(response => response.data)
        );
    }

    public getOrganizacionesByTipoOrganizacion(idTipoOrganizacion: any) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/organizacion/options/by-tipo-organizacion/${idTipoOrganizacion}`).pipe(
            map(response => response.data)
        );
    }

    public getUsuariosForUnidadOrganizacional(id: any, roles: string[]) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-catalogos/usuario-organizacion/organizacion/${id}/rol/options?roles=${roles}`).pipe(
            map(response => response.data)
        );
    }

    public updateAdicionalData(data: any) {
        return this.http.put<EvkResponseType<any>>(`/seaged-diligencias-service/adicional-data-diligencia`, data).pipe(
            map(response => response.data)
        );
    }

    getUsuarioOrganizacionByUsername(username: string) {
        return this.http.get<EvkResponseType<any>>(`/seaged-catalogos/usuario-organizacion/${username}`).pipe(
            map(response => response.data)
        );
    }

    public getCuadrillas = (): Observable<EvkOption[]> => {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-administrador-service/cuadrilla/options`)
            .pipe(map(resoponse => resoponse.data));
    }


    public getDependenciasChihuahua() {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-administrador-service/dependencia/65774be7904bc3288c5c2886/options`).pipe(
            map(response => response.data)
        );
    }
}
